const INITIAL_STATE = {
    registro: {},
    registroUC: {},
    modoTela: "lista",
    modoTelaUC: null,
    aguardando: false,
    lista: [],
    listaSelect: [],
    listaCidade: [],
    listaUnidadeConsumidora: [],
    listaUcValidarUsuarioImplantacao: [],
    listaConcessionaria: [],
    listaConcessionariaAgua: [],
    listaPlataformaMercadoLivre: [],
    listaGrupoFaturamento: [],
    listaModalidadeTarifaria: [],
    listaTipoMercado: [],
    listaModalidadeMercadoLivre: [],
    listaTipoEnergiaMercadoLivre: [],
    listaTipoTransformador: [],
    listaTipoMedicao: [],
    listaSimNao: [
        { id: 1, valor: "Sim" },
        { id: 2, valor: "Não" },
    ],
    listaAnexo: [],
    listaPercentual: (() => {
        let lista = [];
        for (var i = 0; i <= 100; i++) {
            lista.push({ id: i, valor: `${i} %` });
        }
        return lista;
    })(),
    listaGeracaoTipo: [
        { id: "Unidade Geradora (Própria)", valor: "Unidade Geradora (Própria)" }, //2
        { id: "Unidade Geradora/Remota", valor: "Unidade Geradora/Remota" }, //5
        { id: "Unidade Remota", valor: "Unidade Remota" }, //3
        { id: "Remota que virou Geradora", valor: "Remota que virou Geradora" }, //4
    ],
    tiposContratosDemandaAtivosUc: {},
    listaSubgrupoFaturamento: [],
    listaUsuarioAdministrador: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "CLIENTE_MODO_TELA":
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro,
            };

        case "UC_MODO_TELA":
            return {
                ...state,
                modoTelaUC: action.payload.modoUC,
                registroUC: action.payload.registroUC,
            };

        case "CLIENTE_LISTADO":
            return {
                ...state,
                lista: action.payload,
            };
        case "CLIENTE_SELECT_LISTADO":
            return {
                ...state,
                listaSelect: action.payload.data,
            };
        case "CLIENTE_UNIDADE_CONSUMIDORA_SELECT_LISTADO":
            return {
                ...state,
                listaUnidadeConsumidora: action.payload.data,
            };

        case "CLIENTE_SET_AGUARDANDO":
            return { ...state, aguardando: action.payload };

        case "CLIENTE_CONCESSIONARIA_SELECT_LISTADO":
            return {
                ...state,
                listaConcessionaria: action.payload.data,
            };

        case "CLIENTE_CONCESSIONARIA_AGUA_SELECT_LISTADO":
            return {
                ...state,
                listaConcessionariaAgua: action.payload.data,
            };

        case "CLIENTE_PLATAFORMA_MERCADO_LIVRE_SELECT_LISTADO":
            return {
                ...state,
                listaPlataformaMercadoLivre: action.payload.data,
            };

        case "CLIENTE_CIDADE_SELECT_LISTADO":
            return {
                ...state,
                listaCidade: action.payload.data,
            };

        case "CLIENTE_USUARIO_ADMINISTRADOR_SELECT_LISTADO":
            return {
                ...state,
                listaUsuarioAdministrador: action.payload.data,
            };

        case "CLIENTE_TIPO_TRANSFORMADOR_SELECT_LISTADO":
            return {
                ...state,
                listaTipoTransformador: action.payload.data,
            };

        case "CLIENTE_GRUPO_FATURAMENTO_SELECT_LISTADO":
            return {
                ...state,
                listaGrupoFaturamento: action.payload.data,
            };
        case "CLIENTE_SUBGRUPO_FATURAMENTO_SELECT_LISTADO":
            return {
                ...state,
                listaSubgrupoFaturamento: action.payload.data,
            };

        case "CLIENTE_MODALIDADE_TARIFARIA_SELECT_LISTADO":
            return {
                ...state,
                listaModalidadeTarifaria: action.payload.data,
            };

        case "CLIENTE_TIPO_MEDICAO_SELECT_LISTADO":
            return {
                ...state,
                listaTipoMedicao: action.payload.data,
            };

        case "CLIENTE_TIPO_MERCADO_SELECT_LISTADO":
            return {
                ...state,
                listaTipoMercado: action.payload.data,
            };

        case "CLIENTE_MODALIDADE_MERCADO_LIVRE_SELECT_LISTADO":
            return {
                ...state,
                listaModalidadeMercadoLivre: action.payload.data,
            };

        case "CLIENTE_TIPO_ENERGIA_MERCADO_LIVRE_SELECT_LISTADO":
            return {
                ...state,
                listaTipoEnergiaMercadoLivre: action.payload.data,
            };

        case "CLIENTE_ANEXO_LISTADO":
            return {
                ...state,
                listaAnexo: action.payload.data,
            };

        case "UNIDADE_CONSUMIDORA_LISTADO":
            return {
                ...state,
                listaUcValidarUsuarioImplantacao: action.payload.data,
            };

        case "CLIENTE_TIPOS_CONTRATOS_DEMANDA_ATIVOS_UC":
            return {
                ...state,
                tiposContratosDemandaAtivosUc: action.payload,
            };

        default:
            return state;
    }
};
